import { render, staticRenderFns } from "./learnmaterials.vue?vue&type=template&id=48688b28&scoped=true&"
import script from "./learnmaterials.vue?vue&type=script&lang=js&"
export * from "./learnmaterials.vue?vue&type=script&lang=js&"
import style0 from "./learnmaterials.vue?vue&type=style&index=0&id=48688b28&scoped=scoped&lang=scss&"
import style1 from "./learnmaterials.vue?vue&type=style&index=1&id=48688b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48688b28",
  null
  
)

export default component.exports